module.exports = __webpack_public_path__ + "img/login-bg-5.f3cd0f59.jpg";